import { create } from 'zustand';

function createObjectStore<T>(initialState: T) {
  type State = T;

  const useStore = create<State>((set) => ({
    ...initialState,
  }));

  const use = () => {
    return useStore() as State;
  };

  function get() {
    return useStore.getState();
  }

  function update(item: T) {
    useStore.setState((state: State) => {
      return {
        ...state,
        ...item,
      };
    });
  }

  return {
    use,
    update,
    get,
  };
}

export const ObjectStore = {
  create: createObjectStore,
};
